import { IconDotsVertical, IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import { useNavigate } from "react-router-dom";
import formatDate from "../../../utilities/helper";
import EditWarehouseModal from "./EditWarehouseModal";
import { useEffect, useRef, useState } from "react";
import AddCoverageModal from "./AddCoverageModal";
import EditCoverageModal from "./EditCoverageModal";
import DeactivateWarehouseModal from "./DeactivateWarehouseModal";
import { usePermission } from "../../../hooks/usePermissionTabs";

type Props = {
  data: any;
  warehouseRefetch?: any;
  isPending: any;
};

export default function WarehouseOne(props: Props) {
  const Section = ({
    title,
    children,
  }: {
    title: string;
    children: React.ReactNode;
  }) => (
    <div className="  space-y-4 border border-[#d2d2d2] rounded-[20px]  bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  bg-[#F7F6F2]  shadow-sm ">
      <h2 className="text-[#212121]/70 font-medium text-sm">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4">
        {children}
      </div>
    </div>
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <p className="text-sm text-[#1E293B] flex items-center gap-1">
      <span className="font-medium text-[#212121]">{label}:</span> {value}
    </p>
  );
  const { allowed: canCreateWarehouse } = usePermission("warehouse", "create");
  const { allowed: canUpdateWarehouse } = usePermission("warehouse", "update");
  const { allowed: canDeleteWarehouse } = usePermission("warehouse", "delete");
  const [showModal, setShowModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [editCoverage, setEditCoverage] = useState<any>();
  const [showCoverageModal, setShowCoverageModal] = useState(false);
  const [showEditCoverageModal, setShowEditCoverageModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<string>("");

  const navigate = useNavigate();

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className=" ">
      <div className="space-y-4">
        <div
          className="border border-[#d2d2d2] rounded-[20px]  bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  bg-[#F7F6F2]"
          title={""}
        >
          <div className="flex justify-between w-full items-center gap-2 p-4 pb-0">
            <h1 className="text-[#212121] font-medium text-lg">Warehouse </h1>
            <div className="flex items-center gap-2">
              {canUpdateWarehouse && (
                <div className="relative group">
                  <button
                    className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center gap-2 rounded-full justify-center  cursor-pointer text-sm font-medium w-10 h-10"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    <IconEdit size={24} strokeWidth={1.5} />
                  </button>
                  <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                    Edit Warehouse
                  </div>
                </div>
              )}
              {canDeleteWarehouse && (
                <div className="relative group">
                  <button
                    className="bg-red-600 hover:bg-red-700 text-white flex items-center gap-2 rounded-full justify-center cursor-pointer text-sm font-medium w-10 h-10 transition-all duration-200"
                    onClick={() => {
                      setShowDeactivateModal(true);
                    }}
                  >
                    <IconTrash size={22} strokeWidth={1.5} />
                  </button>
                  <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                    Deactivate Warehouse
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 w-full col-span-4 p-4 ">
            <TwoCol label="Name" value={props?.data?.name} />
            <TwoCol label="Country" value={props?.data?.countryName} />
            <TwoCol label="City" value={props?.data?.cityName} />
            <TwoCol label="District" value={props?.data?.districtName} />
            <TwoCol label="Zip Code" value={props?.data?.zipCode} />
            <TwoCol
              label="Created Date"
              value={formatDate(props?.data?.createdAt)}
            />
            <TwoCol label="Short Address" value={props?.data?.shortAddress} />
            <div className="col-span-1">
              <p className="text-sm text-[#1E293B] flex   gap-1">
                <span className="font-medium text-[#212121]">Address:</span>{" "}
                {props?.data?.location}
              </p>
            </div>
          </div>
        </div>
        <Section title=" ">
          <div className="flex justify-between items-center col-span-4 px-4 ">
            <div className="flex items-center gap-2">
              <h1 className="text-[#212121] font-medium text-lg">Coverage</h1>
            </div>
            {props?.data?.covrage?.length > 0 ? (
              (canCreateWarehouse || canUpdateWarehouse) && (
                <button
                  className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center gap-2 rounded-full justify-center   w-10 h-10  cursor-pointer text-sm font-medium"
                  onClick={() => {
                    setSelectedWarehouse(props?.data?.id);
                    setShowCoverageModal(true);
                  }}
                >
                  <IconPlus stroke={1.5} size={24} />
                </button>
              )
            ) : (
              <></>
            )}
          </div>
          <div className="col-span-4">
            {props?.data?.covrage?.length > 0 ? (
              <ListView
                mainDivClassName="bg-transparent  p-0"
                mailDivClassName="p-0 bg-transparent"
                data={props.data.covrage
                  ?.map((coverage: any) =>
                    coverage?.countries?.map((country: any) => ({
                      ...country,
                      covrageName: coverage?.covrageName, // attach coverage name to country
                      covrageType: coverage?.covrageType,
                      covrageCountry: coverage?.covrageCountry,
                      covrageCity: coverage?.covrageCity,
                      id: coverage?.id,
                      createdAt: coverage?.createdAt
                    }))
                  )
                  ?.flat()}
                columns={[
                  { label: "#", render: (_, i) => i + 1 },
                  {
                    label: "Name",
                    render: (c: any) => c?.covrageName,
                  },
                  {
                    label: "Country",
                    render: (c: any) => c.countryName,
                  },
                  { label: "Country Code", render: (c) => c.countryCode },
                  {
                    label: "Currency Code",
                    render: (c: any) => c.currencyCode,
                  },
                  { label: "Dial Code", render: (c: any) => c.dialCode },
                  {
                    label: "Cities",
                    render: (c: any) =>
                      c.covrage?.length > 0 && c?.covrageType !== "country"
                        ? c?.covrageType === "city"
                          ? c?.covrage?.length
                          : 1
                        : c?.totalCities,
                  },
                  {
                    label: "Created Date",
                    render: (c: any) => formatDate(c?.createdAt),
                  },
                  {
                    label: "Actions",
                    render: (c: any, i: number) => (
                      <div className="relative flex justify-center">
                        <button
                          onClick={() =>
                            setOpenDropdownIndex(
                              openDropdownIndex === i ? null : i
                            )
                          }
                          className="p-2 border rounded-full bg-[#F7F6F2]"
                        >
                          <IconDotsVertical size={22} />
                        </button>

                        {openDropdownIndex === i && (
                          <div
                            ref={dropdownRef}
                            className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-16 -top-6 z-50 mt-2 w-24 rounded-xl shadow-lg overflow-hidden"
                          >
                            <div
                              onClick={() => {
                                navigate(
                                  `/view-coverage-cities-details/${c.countryName}`,
                                  {
                                    state: {
                                      warehouseName: props?.data?.name,
                                      coverageCities:
                                        c?.covrageType === "district"
                                          ? [c?.covrageCity]
                                          : c?.covrage,
                                      countryId: c?.countryId,
                                      countryName: c?.countryName,
                                      createdAt: c?.createdAt,
                                      covrage:
                                        c?.covrageType === "district"
                                          ? c?.covrage
                                          : undefined,
                                      covrageType: c?.covrageType,
                                    },
                                  }
                                );
                              }}
                              className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                            >
                              View
                            </div>
                             {canUpdateWarehouse && (
                               <div
                                 onClick={() => {
                                   setEditCoverage(c);
                                   setSelectedWarehouse(props?.data?.id);
                                   setShowEditCoverageModal(true);
                                 }}
                                 className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                               >
                                 Edit
                               </div>
                             )}
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-3xl p-8 flex flex-col items-center">
                <img src="/img/scan-data.png" alt="scan prompt" />
                <div className="text-center">
                  <h2 className="text-[#212121] text-lg font-medium">
                    Add Coverage
                  </h2>
                  <h2 className="text-[#212121]/70 text-sm">
                    Add Coverage based on country , city and District wise
                  </h2>
                </div>
                {(canCreateWarehouse || canUpdateWarehouse) && (
                  <div className="mt-4">
                    <button
                      className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center gap-2 rounded-full p-2 px-6 cursor-pointer text-sm font-medium"
                      onClick={() => {
                        setSelectedWarehouse(props?.data?.id);
                        setShowCoverageModal(true);
                      }}
                    >
                      <span>
                        <IconPlus stroke={1.5} size={20} />
                      </span>{" "}
                      Add Coverage
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </Section>
      </div>

      {showModal && (
        <EditWarehouseModal
          warehouseDetails={props?.data}
          onClose={() => setShowModal(false)}
        />
      )}
      {showEditCoverageModal && (
        <EditCoverageModal
          onClose={() => {
            setShowEditCoverageModal(false);
            setSelectedWarehouse("");
          }}
          warehouseDetails={editCoverage}
          selectedWarehouse={selectedWarehouse}
        />
      )}
      {showCoverageModal && (
        <AddCoverageModal
          onClose={() => {
            setShowCoverageModal(false);
            setSelectedWarehouse("");
          }}
          selectedWarehouse={selectedWarehouse}
        />
      )}
      {showDeactivateModal && (
        <DeactivateWarehouseModal
          warehouseDetails={props?.data}
          onClose={() => setShowDeactivateModal(false)}
        />
      )}
    </div>
  );
}
